import { formatDate, formatDateWithTime } from '@folio/lib';
import type { DateFormat } from 'korint-sdk/react';

interface DateCellProps {
  value: Date;
  format?: DateFormat;
}

const DATE_FORMATTERS: Record<DateFormat, (input: Date) => string> = {
  date: formatDate,
  datetime: formatDateWithTime,
};

export function DateCell({ value, format }: DateCellProps) {
  const formatter = format && DATE_FORMATTERS[format];

  return formatter && value ? formatter(value) : value?.toISOString();
}
